import { collection, addDoc, getDocs, query, where, updateDoc } from 'firebase/firestore';
import { db } from '../firebase/firebaseConfig';

// ข้อมูลน้องๆ จริงที่ต้องการเพิ่มเข้าไปในฐานข้อมูล
const realGirlsData = [
  {
    nickname: 'เอ๊ะ ดีแต่ปาก',
    grades: 4.5,
    type: 'vn',
    subscription: 'premium',
    description: 'เล่นได้ ดื่มเก่ง',
    momoName: 'มอมจอย',
    height: 165,
    weight: 50,
    skinTone: 'fair',
    servicePrice: 1500,
    coinPrice: 50,
    commission: 0.3,
    prices: { 
      base: 50,
      servicePrice: 1500,
      coinPrice: 50
    },
    location: 'กาญจนบุรี',
    bio: 'เล่นได้ ดื่มเก่ง',
    lineType: 'self',
    lineContact: 'ae123',
    images: ['https://via.placeholder.com/300x400/FFB6C1/FFFFFF?text=Ae'],
    status: 'available'
  },
  {
    nickname: 'ฝ้าย น่างับ',
    grades: 4.8,
    type: 'vn',
    subscription: 'premium',
    description: 'สาวน่ารัก หน้าตาดี บริการดีมาก มีประสบการณ์',
    momoName: 'มอมแอม',
    height: 160,
    weight: 48,
    skinTone: 'light',
    servicePrice: 2500,
    coinPrice: 80,
    commission: 0.35,
    prices: { 
      base: 80,
      servicePrice: 2500,
      coinPrice: 80
    },
    location: 'กาญจนบุรี',
    bio: 'สาวน่ารัก หน้าตาดี',
    lineType: 'modeling',
    lineContact: 'fai123',
    images: ['https://via.placeholder.com/300x400/FFC0CB/FFFFFF?text=Fai'],
    status: 'available'
  },
  {
    nickname: 'น้องใหม่',
    grades: 4.2,
    type: 'strong',
    subscription: 'vip',
    description: 'สาวแกร่ง ใจดี มีความมั่นใจสูง บริการดีเยี่ยม',
    momoName: 'มอมซี',
    height: 170,
    weight: 55,
    skinTone: 'medium',
    servicePrice: 1800,
    coinPrice: 60,
    commission: 0.32,
    prices: { 
      base: 60,
      servicePrice: 1800,
      coinPrice: 60
    },
    location: 'กาญจนบุรี',
    bio: 'สาวแกร่ง ใจดี',
    lineType: 'self',
    lineContact: 'new123',
    images: ['https://via.placeholder.com/300x400/DDA0DD/FFFFFF?text=New'],
    status: 'available'
  }
];

// ฟังก์ชันสำหรับเพิ่มข้อมูลน้องๆ จริงเข้า Firestore
export const addRealGirlsData = async () => {
  try {
    // ตรวจสอบว่ามีข้อมูลอยู่แล้วหรือไม่
    const girlsRef = collection(db, 'girls');
    const q = query(girlsRef, where('status', '==', 'available'));
    const existingGirls = await getDocs(q);
    
    if (existingGirls.docs.length > 0) {
      alert('มีข้อมูลน้องๆ อยู่แล้วในระบบ! ใช้ "อัพเดทข้อมูล" แทน');
      return;
    }

    // เพิ่มข้อมูลน้องๆ จริงทีละคน
    const promises = realGirlsData.map(async (girl) => {
      try {
        await addDoc(girlsRef, {
          ...girl,
          createdAt: new Date(),
          updatedAt: new Date()
        });
        console.log(`✅ เพิ่มข้อมูล ${girl.nickname} สำเร็จ`);
      } catch (error) {
        console.error(`❌ ไม่สามารถเพิ่มข้อมูล ${girl.nickname}:`, error);
      }
    });

    await Promise.all(promises);
    
    alert('เพิ่มข้อมูลน้องๆ จริงสำเร็จ! รีเฟรชหน้าเว็บเพื่อดูผลลัพธ์');
    console.log('✅ เพิ่มข้อมูลน้องๆ จริงทั้งหมดสำเร็จ');
    
  } catch (error) {
    console.error('❌ ไม่สามารถเพิ่มข้อมูลน้องๆ จริง:', error);
    alert('เกิดข้อผิดพลาด: ' + error.message);
  }
};

// ฟังก์ชันสำหรับอัพเดทข้อมูลน้องๆ จริงที่มีอยู่แล้ว
export const updateRealGirlsData = async () => {
  try {
    const girlsRef = collection(db, 'girls');
    const snapshot = await getDocs(girlsRef);
    
    const promises = snapshot.docs.map(async (doc) => {
      const data = doc.data();
      
      // อัพเดทข้อมูลตามชื่อ
      let updateData = {};
      
      if (data.nickname === 'เอ๊ะ ดีแต่ปาก') {
        updateData = {
          subscription: 'premium',
          description: 'เล่นได้ ดื่มเก่ง',
          bio: 'เล่นได้ ดื่มเก่ง',
          momoName: 'มอมจอย'
        };
      } else if (data.nickname === 'ฝ้าย น่างับ') {
        updateData = {
          subscription: 'premium',
          description: 'สาวน่ารัก หน้าตาดี บริการดีมาก มีประสบการณ์',
          momoName: 'มอมแอม'
        };
      } else if (data.nickname === 'น้องใหม่') {
        updateData = {
          subscription: 'vip',
          description: 'สาวแกร่ง ใจดี มีความมั่นใจสูง บริการดีเยี่ยม',
          momoName: 'มอมซี'
        };
      } else {
        // สำหรับน้องอื่นๆ ที่ไม่ตรงกับข้อมูลจริง
        updateData = {
          subscription: data.subscription || 'free',
          description: data.description || data.bio || 'น้องน่ารัก บริการดี',
          momoName: data.momoName || 'มอมจอย'
        };
      }
      
      if (Object.keys(updateData).length > 0) {
        await updateDoc(doc.ref, {
          ...updateData,
          updatedAt: new Date()
        });
        console.log(`✅ อัพเดทข้อมูล ${data.nickname} สำเร็จ`);
      }
    });
    
    await Promise.all(promises);
    
    alert('อัพเดทข้อมูลน้องๆ จริงสำเร็จ! รีเฟรชหน้าเว็บเพื่อดูผลลัพธ์');
    console.log('✅ อัพเดทข้อมูลน้องๆ จริงทั้งหมดสำเร็จ');
    
  } catch (error) {
    console.error('❌ ไม่สามารถอัพเดทข้อมูลน้องๆ จริง:', error);
    alert('เกิดข้อผิดพลาด: ' + error.message);
  }
};
